import {
  type GetSessionsAnalyticsActivityArgs,
  useLazyGetSessionsAnalyticsActivityQuery,
} from '@carboncopyco/data';
import type { Resolution, TimePeriod } from '@carboncopyco/types';
import {
  getDateFromDaysAgo,
  getNowInFormat,
  getTimezoneName,
  useDemoAnalytics,
} from '@carboncopyco/utils';
import { useEffect, useMemo, useState } from 'react';
import { SingleBarChart, useGetActivityChartConfig } from '../../../Charts';
import { useOverlayPageProps } from '../OverlayPageContext';

export const ActivityOverTime = () => {
  const { organizationId, demoId, workspaceId } = useOverlayPageProps();
  const { trackDemoSelectTimeFilter } = useDemoAnalytics('analytics_page');

  const [resolution, setResolution] = useState<Resolution>('day');
  const [timePeriod, setTimePeriod] = useState<TimePeriod>('30');

  const fetchArgs: GetSessionsAnalyticsActivityArgs = useMemo(
    () => ({
      organizationId,
      shortSessions: true,
      internalSessions: true,
      workspaceIds: [workspaceId],
      start: getDateFromDaysAgo(Number(timePeriod)),
      end: getNowInFormat('YYYY-MM-DDTHH:mm:ssZ'),
      timezone: getTimezoneName(),
      resolution,
      demoId,
      resourceTypes: ['managed_presentation'],
    }),
    [organizationId, workspaceId, timePeriod, resolution, demoId]
  );

  const [getManagedPresentationOverTimeChart, { data, isFetching, isError }] =
    useLazyGetSessionsAnalyticsActivityQuery();

  useEffect(() => {
    getManagedPresentationOverTimeChart(fetchArgs);
  }, [fetchArgs, getManagedPresentationOverTimeChart]);

  const chartData = useGetActivityChartConfig(data, 'presented', timePeriod);
  const isEmpty = !data?.results.length;

  useEffect(() => {
    if (timePeriod === '7') {
      setResolution('day');
    }
  }, [timePeriod]);

  return (
    <SingleBarChart
      isLoading={isFetching}
      isError={isError}
      isEmpty={isEmpty}
      chartData={chartData}
      resolution={resolution}
      setResolution={setResolution}
      trackEvent={() =>
        trackDemoSelectTimeFilter({
          period: timePeriod,
          resolution,
        })
      }
      timePeriod={timePeriod}
      setTimePeriod={setTimePeriod}
      chartHeight={210}
    />
  );
};
